export default "__VITE_ASSET__DTmX$0Dl__"